/* =========================================================
   CasaTextil - Filtro correcto de variantes con stock
   REGLAS:
   - COLOR: mostrar todos los colores con al menos 1 variante disponible
   - KILOS / METROS: mostrar solo los que existan para el color seleccionado
   ========================================================= */

(function () {
  function getVariants(root) {
    const json = root.querySelector('script[type="application/json"]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent) || [];
    } catch {
      return [];
    }
  }

  function getFieldsets(root) {
    return Array.from(root.querySelectorAll('fieldset[data-option-position]'));
  }

  function getSelectedValue(root, position) {
    const input = root.querySelector(
      `input[type="radio"][data-option-position="${position}"]:checked`
    );
    return input ? input.value : null;
  }

  function updateLegend(fieldset) {
    const pos = fieldset.dataset.optionPosition;
    const checked = fieldset.querySelector(
      `input[type="radio"][data-option-position="${pos}"]:checked`
    );
    const span = fieldset.querySelector('.product-form__input__option-value');
    if (span && checked) span.textContent = checked.value;
  }

  function filterColors(root, variants, fieldset) {
    const pos = Number(fieldset.dataset.optionPosition);
    const items = fieldset.querySelectorAll('li[data-value]');

    items.forEach(li => {
      const value = li.dataset.value;
      const hasStock = variants.some(v =>
        v.available === true && v[`option${pos}`] === value
      );
      li.style.display = hasStock ? '' : 'none';
    });
  }

  function filterSecondaryOptions(root, variants, fieldset, colorPos, selectedColor) {
    const pos = Number(fieldset.dataset.optionPosition);
    const items = fieldset.querySelectorAll('li[data-value]');

    let firstVisibleInput = null;

    items.forEach(li => {
      const value = li.dataset.value;

      const exists = variants.some(v =>
        v.available === true &&
        v[`option${colorPos}`] === selectedColor &&
        v[`option${pos}`] === value
      );

      li.style.display = exists ? '' : 'none';

      if (exists && !firstVisibleInput) {
        firstVisibleInput = li.querySelector('input[type="radio"]');
      }
    });

    const checked = fieldset.querySelector(
      `input[type="radio"][data-option-position="${pos}"]:checked`
    );

    if (!checked || checked.closest('li').style.display === 'none') {
      if (firstVisibleInput) {
        firstVisibleInput.checked = true;
        firstVisibleInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    }

    updateLegend(fieldset);
  }

  function run(root) {
    const variants = getVariants(root);
    if (!variants.length) return;

    const fieldsets = getFieldsets(root);
    if (fieldsets.length < 2) return;

    const colorFieldset = fieldsets[0];
    const colorPos = Number(colorFieldset.dataset.optionPosition);
    const selectedColor = getSelectedValue(root, colorPos);

    // 1️⃣ COLOR → siempre mostrar todos los colores con stock
    filterColors(root, variants, colorFieldset);
    updateLegend(colorFieldset);

    if (!selectedColor) return;

    // 2️⃣ RESTO (Kilos / Metros) → depende del color seleccionado
    fieldsets.slice(1).forEach(fs => {
      filterSecondaryOptions(root, variants, fs, colorPos, selectedColor);
    });
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(root => {
      setTimeout(() => run(root), 0);
      setTimeout(() => run(root), 80);
      setTimeout(() => run(root), 200);

      root.addEventListener('change', () => {
        setTimeout(() => run(root), 0);
        setTimeout(() => run(root), 60);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

